import { ArrowRight, CalendarClockIcon } from 'assets/icons';
import useHomeText from 'hooks/useHomeText';

// The appointments booked but not placed in the planning yet, in red, with
// those due before tomorrow.
const AppointmentsToPlace = ({ total, beforeTomorrow, onClick }) => {
  const { text } = useHomeText();
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center gap-2.5 rounded-xl bg-red-50 py-2.5 pl-3 pr-2.5 text-left text-red-700 transition-colors hover:bg-red-100"
    >
      <span className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-red-100">
        <CalendarClockIcon wh={18} color="currentColor" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold">{text('agenda.toPlace', { count: total })}</span>
        {beforeTomorrow > 0 && (
          <span className="block text-xs">{text('agenda.urgent', { count: beforeTomorrow })}</span>
        )}
      </span>
      <ArrowRight wh={18} color="currentColor" />
    </button>
  );
};

export default AppointmentsToPlace;
